var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('router-link',{class:_vm.anchorClass,attrs:{"to":_vm.anchorLink}},[(_vm.inverseLogo)?_c('img',{staticClass:"inverse",attrs:{"src":_vm.inverseLogo}}):_vm._e(),(_vm.mainLogo)?_c('img',{staticClass:"main",attrs:{"src":_vm.mainLogo}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }